export const environment = {
  disableLogging: true,
  production: true,
  platform: 'DEV',
  keycloakConfig: {
    url: 'https://login-dev.sde-ild.soletanche-bachy.org',
    realm: 'Dev',
    clientId: 'SoilLib',
    'ssl-required': 'external',
    'public-client': true,
  },
  gaEnabled: true,
  gaIdMesure: 'G-MYMW0YLZY8',
  uaId: 'UA-147463668-2',
  googleSearchApiKey: 'AIzaSyCiGbSZZ8hZW12O-TrngTRUfrZT1WTmdAU',
  mapTilerKey: 'U7i4r6e78ueJ9XAAuhC5',
  azureMapsApiKey: 'Bi0TrSGApPF3zeaFlTBccmFdB8PISOZ8lfHysEzm6RDWJzpbYuk3JQQJ99BGAC5RqLJQQOUTAAAgAZMP4flD',
  sentry: {
    enabled: true,
    dsn: 'https://eb397870ac654822b8790059af10ad8c@glitchtip.sde-ild.soletanche-bachy.org/5',
    tracesSampleRate: 1.0,
  },
  documentation: {
    agsSoilTypes: 'https://support-ild.atlassian.net/wiki/spaces/ZHELP/pages/4063242/AGS+Soil+types',
  },
  features: {
    soilCompactness: false,
  },
}
